(function () {
  'use strict';

  var PAGE_URL = '/pages/cashback';
  var RATE = 0.03;
  var ROOT_ATTR = 'data-strongant-cashback-promo';

  function euro(cents) {
    return (Math.floor(cents * RATE) / 100).toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR',
    });
  }

  function styleOnce() {
    if (document.getElementById('strongant-cashback-promo-style')) return;
    var style = document.createElement('style');
    style.id = 'strongant-cashback-promo-style';
    style.textContent =
      '.sa-cashback-promo{display:flex;gap:.7rem;align-items:flex-start;margin:1rem 0;padding:.9rem 1rem;border:1px solid #e8e4df;border-left:3px solid #fe4812;border-radius:12px;background:#f8f6f3;color:#0a0a0a;font:600 14px/1.4 system-ui,-apple-system,sans-serif}' +
      '.sa-cashback-promo__badge{flex:0 0 auto;background:#fe4812;color:#fff;border-radius:999px;padding:.22rem .55rem;font-size:12px;font-weight:800}' +
      '.sa-cashback-promo__text{min-width:0}.sa-cashback-promo__text strong{display:block;margin-bottom:.12rem}' +
      '.sa-cashback-promo__text span{color:#5c5c5c;font-weight:500}' +
      '.sa-cashback-promo a{color:#0a0a0a;text-decoration:underline;text-underline-offset:2px}' +
      '.sa-cashback-promo--cart{margin:1rem 0 1.25rem}' +
      '@media(max-width:600px){.sa-cashback-promo{font-size:13px}}';
    document.head.appendChild(style);
  }

  function promo(text, detail, cart) {
    var box = document.createElement('div');
    box.className = 'sa-cashback-promo' + (cart ? ' sa-cashback-promo--cart' : '');
    box.setAttribute(ROOT_ATTR, cart ? 'cart' : 'product');
    box.innerHTML =
      '<span class="sa-cashback-promo__badge">3 %</span>' +
      '<div class="sa-cashback-promo__text"><strong>' +
      text +
      '</strong><span>' +
      detail +
      ' <a href="' +
      PAGE_URL +
      '">So funktioniert Cashback</a></span></div>';
    return box;
  }

  function insertProductPromo() {
    if (!/^\/products\//.test(location.pathname)) return;
    if (document.querySelector('[' + ROOT_ATTR + '="product"]')) return;
    var form =
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('product-form') ||
      document.querySelector('[data-product-form]');
    if (!form || !form.parentNode) return;
    var box = promo(
      'Dein Einkauf zahlt sich doppelt aus.',
      'Nach erfolgreicher Zahlung erhältst du 3 % als Gutschein für deinen nächsten Einkauf.',
      false
    );
    if (
      location.pathname ===
      '/products/kochjacke-herren-soft-stretch-langarm'
    ) {
      form.parentNode.insertBefore(box, form.nextSibling);
    } else {
      form.parentNode.insertBefore(box, form);
    }
  }

  function insertCartPromo() {
    if (location.pathname !== '/cart') return;
    if (document.querySelector('[' + ROOT_ATTR + '="cart"]')) return;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('cart');
        return res.json();
      })
      .then(function (cart) {
        if (!cart || !cart.items_subtotal_price || cart.item_count <= 0) return;
        var anchor =
          document.querySelector('[data-cart-footer]') ||
          document.querySelector('.cart__footer') ||
          document.querySelector('form[action="/cart"]') ||
          document.querySelector('main');
        if (!anchor || !anchor.parentNode) return;
        var box = promo(
          euro(Number(cart.items_subtotal_price)) + ' Cashback vorgemerkt',
          'Der Gutschein wird nach erfolgreicher Zahlung automatisch in „Mein Konto“ verfügbar.',
          true
        );
        anchor.parentNode.insertBefore(box, anchor);
      })
      .catch(function () {
        // Kein irreführender Fallback, wenn der Warenkorb nicht gelesen werden kann.
      });
  }

  function boot() {
    styleOnce();
    insertProductPromo();
    insertCartPromo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
